import type { DriveStep } from 'driver.js';

export const staffInventoryTourId = 'staff:inventory';

export const staffInventorySteps: DriveStep[] = [
  {
    element: '[data-tour="staff:inventory-stock"]',
    popover: {
      title: 'Остатки',
      description:
        'Таблица текущих остатков по всем товарам вашего пункта. Показывает SKU, название и количество на складе.',
    },
  },
  {
    element: '[data-tour="staff:inventory-check-btn"]',
    popover: {
      title: 'Инвентаризация',
      description:
        'Начните инвентаризацию: обойдите товары, запишите фактическое количество, система покажет расхождения.',
    },
  },
  {
    element: '[data-tour="staff:help-btn"]',
    popover: {
      title: 'Помощь',
      description: 'Кнопка помощи для повторного обучения.',
    },
  },
];
